import { useState, useEffect } from 'react';

export default function SettlementTracker() {
  const [totalRecovered, setTotalRecovered] = useState(100000);

  useEffect(() => {
    const interval = setInterval(() => {
      setTotalRecovered(prev => {
        const increment = Math.floor(Math.random() * 500) + 100; // Random increment between 100-600
        const newAmount = prev + increment;
        
        // Stop at $600,000 and restart from $100,000
        if (newAmount >= 600000) {
          return 100000;
        }
        
        return newAmount;
      });
    }, 500); // Faster interval - 500ms (half a second)

    return () => clearInterval(interval);
  }, []);

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 py-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Justice in Motion
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            No case is too small, and no fight is too big for our team.
          </p>
        </div>

        {/* Live Counter */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 mb-12 border border-white/20">
          <div className="text-center">
            <div className="text-sm font-semibold text-cyan-300 mb-4 uppercase tracking-wider">
              Total Recovered for Clients
            </div>
            <div className="text-6xl lg:text-7xl font-bold text-white mb-4 font-mono">
              {formatCurrency(totalRecovered)}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Ready to Get the Compensation You Deserve?
          </h3>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto">
            Don't wait - every day matters when it comes to your personal injury case. 
            Get your free consultation today and join our growing list of successful settlements.
          </p>
          <button className="bg-cyan-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-cyan-600 transition-colors cursor-pointer whitespace-nowrap">
            Start Your Free Case Review
          </button>
        </div>
      </div>
    </section>
  );
}
